import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { Suspense, lazy } from "react";
import { Outlet } from "react-router";

import { BetaVersion } from "@components/BetaVersion";
import { GeoRestrictionBanner } from "@components/GeoRestrictionBanner";
import { SideBarAssets } from "@components/SideBarAssets";
import { TabTitleUpdater } from "@components/TabTitleUpdater";

import { Footer } from "./Footer";
import { Header } from "./Header";

const ConnectWallet = lazy(() =>
  import("@components/ConnectWalletDialogs/ConnectWallet").then((m) => ({ default: m.ConnectWallet })),
);
const DepositDialog = lazy(() => import("@components/VaultDialog").then((m) => ({ default: m.DepositDialog })));
const WithdrawDialog = lazy(() => import("@components/VaultDialog").then((m) => ({ default: m.WithdrawDialog })));
const TransferDialog = lazy(() => import("@components/VaultDialog").then((m) => ({ default: m.TransferDialog })));
const LongShortActionsMobile = lazy(() =>
  import("@components/LongShortActionsMobile").then((m) => ({ default: m.LongShortActionsMobile })),
);

export const GlobalLayout = observer(() => {
  return (
    <LayoutContainer data-testid="trade:layout">
      <TabTitleUpdater />
      <Header />
      <GeoRestrictionBanner />
      <BetaVersion />
      <ContainerOutlet data-testid="trade:content">
        <Outlet />
      </ContainerOutlet>
      <SideBarAssets />
      <Footer />

      <Suspense fallback={null}>
        <ConnectWallet />
        <DepositDialog />
        <WithdrawDialog />
        <TransferDialog />
        <LongShortActionsMobile />
      </Suspense>
    </LayoutContainer>
  );
});

const LayoutContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  height: 100vh;

  position: relative;
`;

const ContainerOutlet = styled.main`
  padding: 0 4px;
  width: 100%;
  flex: 1;
`;
